import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	FileGroup,
	TextAreaField,
	// SelectFieldStatus
} from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { LeaseeInformation, LeasorInformation, RequestInformationLease } from "../partials/FormFieldsLease";
import { ApprenticeInformation, InvestorInformation, RequestInformationAF } from "../partials/FormFieldsAF";
import DeliveryInfo from "../partials/DeliveryInfo";

// eslint-disable-next-line no-unused-vars
const PurchasedForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const [newInfo, setNewInfo] = useState({
		pickupAddress: requestData?.deliveryInfo?.pickupAddress || "",
		deliveryDate: requestData?.deliveryInfo?.deliveryDate || "",
		agentName: requestData?.deliveryInfo?.deliveryAgent || "",
		agentNumber: requestData?.deliveryInfo?.agentNumber || "",
		deliveryFee: requestData?.deliveryInfo?.deliveryFee || "",
	});

	const miniInfo = {
		engineNum: formData?.vehicleInfo?.engineNum,
		chassisNum: formData?.vehicleInfo?.chassisNum,
		assetInvoice: formData?.assetInvoice || formData?.vehicleInfo?.assetInvoice,
		hardCopyReceipt: formData?.hardCopyReceipt || formData?.vehicleInfo?.hardCopyReceipt,
	};

	// console.log(requestData);

	const handleChange = (e) => {
		setNewInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleNumberChange = (e) => {
		if (isNaN(e.target.value)) {
			return;
		}
		setNewInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	// eslint-disable-next-line no-unused-vars
	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setRequestData(formData);
		// updateCurrentObject(formData);
	};

	const updatedData = {
		lease: {
			deliveryInfo: {
				deliveryAgent: newInfo.agentName,
				deliveryFee: newInfo.deliveryFee,
				agentNumber: newInfo.agentNumber,
				deliveryDate: newInfo.deliveryDate,
				pickupAddress: newInfo.pickupAddress,
				deliveryFeeStatus: requestData?.deliveryInfo?.deliveryFeeStatus || "pending",
			},
			dateOfDeployment: requestData?.dateOfDeployment
				? requestData?.dateOfDeployment
				: requestData?.deliveryInfo?.deliveryFeeStatus === "paid"
				? new Date().toISOString()
				: "",
		},
		AfData: {
			deliveryInfo: {
				deliveryAgent: newInfo.agentName,
				deliveryFee: newInfo.deliveryFee,
				agentNumber: newInfo.agentNumber,
				deliveryDate: newInfo.deliveryDate,
				deliveryFeeStatus: requestData?.deliveryInfo?.deliveryFeeStatus || "pending",
			},
			dateOfDeployment: requestData?.dateOfDeployment
				? requestData?.dateOfDeployment
				: requestData?.deliveryInfo?.deliveryFeeStatus === "paid"
				? new Date().toISOString()
				: "",
		},
	};

	const data = {
		lease: {
			dateOfDeployment: new Date().toISOString(),
		},
	};

	const deployementInfo = formData?.productObj?.category === "Vehicles" ? updatedData?.lease : data?.lease;

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					canEditStatus={true}
					updatedData={updatedData}
					isEditable={isEditable}
					options={["deployed"]}
					keyValue='deliveryInfo'
					assetDateToUpdate={deployementInfo}
				/>

				<div className='RightSection'>
					<FormAccordion title='Request Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RequestInformationLease
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									except={["approvalStatus", "disbursement"]}
									miniInfo={miniInfo}
									fileInfo={miniInfo?.assetInvoice}
									hardCopyReceipt={miniInfo?.hardCopyReceipt}
									fileOneEnabled={false}
									fileTwoEnabled={false}
									showDeliveryDetails
								/>
							) : (
								<RequestInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									except={["approvalStatus", "disbursement"]}
									fileInfo={requestData?.paymentReceipt}
									hardCopyReceipt={requestData?.hardCopyReceipt}
									fileOneEnabled={false}
									fileTwoEnabled={false}
								/>
							)}
						</div>
					</FormAccordion>
					{isLeasing ? (
						<>
							<FormAccordion title='Delivery Information' open>
								<DeliveryInfo
									requestData={formData}
									handleChange={handleChange}
									handleNumberChange={handleNumberChange}
									data={newInfo}
									isEditable={isEditable}
								/>
							</FormAccordion>
							<FormAccordion title='Product description'>
								<div className='form-group'>
									<TextAreaField
										name='product_desc'
										value={formData?.description || formData?.productId?.description}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Key features'>
								<div className='form-group'>
									<TextAreaField
										name='keyFeatures'
										value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Product specifications'>
								<div className='form-group'>
									<TextAreaField
										name='specifications'
										value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Leasor’s Information'>
								<LeasorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Leasee’s Information'>
								<LeaseeInformation formData={formData} />
							</FormAccordion>
						</>
					) : (
						<>
							<FormAccordion title='Delivery Information' open>
								<DeliveryInfo
									requestData={formData}
									handleChange={handleChange}
									handleNumberChange={handleNumberChange}
									data={newInfo}
									isEditable={isEditable}
								/>
							</FormAccordion>
							<FormAccordion title='Proof of purchase'>
								<div className='form-group'>
									<FileGroup value={formData?.proofOfPurchaseFile?.url} />
								</div>
							</FormAccordion>

							<FormAccordion title='Investor’s Information'>
								<InvestorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Apprentice’s Information'>
								<ApprenticeInformation formData={formData} />
							</FormAccordion>
						</>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
PurchasedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
	// updateCurrentObject: PropTypes.func,
};

export default PurchasedForm;
